<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="loaded ? ('Edit ' | translate) + member?.first_name : ''"
      [canGoBack]="true"
      [showLinkIcon]="true"
      [linkIcon]="'trash'"
      (linkAction)="deleteMember()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

      @if (loaded) {
        <tidy-card>
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-input
              formControlName="firstName"
              [form]="form.controls.firstName"
              [label]="'First Name'"
              [errorMessage]="'Please enter their first name.'"
              [submitted]="submitted"
              [icon]="'assets/svg/person.svg'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="lastName"
              [form]="form.controls.lastName"
              [label]="'Last Name'"
              [errorMessage]="'Please enter their last name.'"
              [submitted]="submitted"
              [icon]="'assets/svg/person.svg'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="email"
              [form]="form.controls.email"
              [label]="'Email'"
              type="email"
              [errorMessage]="'Please enter a valid email'"
              [submitted]="submitted"
              [icon]="'assets/svg/mail.svg'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="password"
              [form]="form.controls.password"
              [label]="'Password'"
              [errorMessage]="'Password enter a password.'"
              [submitted]="submitted"
              type="password"
              [icon]="'assets/svg/lock-closed.svg'" />
          </tidy-row>
          <tidy-row [ngClass]="member?.role !== 'owner' ? 'field-bottom-padding' : ''">
            <tidy-input-international-phone
              formControlName="phone"
              [label]="'Their Phone'"
              [form]="form.controls.phone"
              [inputMode]="'numeric'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a valid phone.'"
              [icon]="'assets/svg/phone-portrait.svg'"
              [initialMask]="{ mask: '[00000000000000000000000]' }"
              (countryCodeChange)="onCountryCodeChange($event)" />
          </tidy-row>
          @if (member?.role !== 'owner' && clientInfo?.customer_account?.account_type !== 'regular') {
            <tidy-row>
              <tidy-select
                [icon]="'assets/svg/information-circle.svg'"
                [label]="'User Type'"
                [items]="roleItems"
                [form]="form.controls.role"
                formControlName="role"
                [submitted]="submitted"
                [errorMessage]="'Please select a user type'" />
            </tidy-row>
            <tidy-row [align]="'center'" [ngClass]="user?.role === 'admin' && form?.value?.role === 'member' ? 'extra-bottom-padding' : ''">
              <tidy-text
                [helper]="'Account admins can see all users and properties. Group managers can only see users and properties on their group.'" />
            </tidy-row>
            @if (member?.role === 'admin' && form?.value?.role === 'member') {
              @if (teamItems?.length > 0) {
                <tidy-row>
                  <tidy-select
                    [icon]="'assets/svg/location-outline.svg'"
                    [label]="'Add to Group'"
                    [items]="teamItems"
                    [form]="form.controls.team"
                    formControlName="team"
                    [submitted]="submitted"
                    [errorMessage]="'Please select a group'" />
                </tidy-row>
              }
              @if (teamItems?.length == 0) {
                <tidy-row>
                  <tidy-text
                    [body]="'Create your first group:'" />
                </tidy-row>
                <tidy-row>
                  <tidy-input
                    formControlName="teamName"
                    [form]="form.controls.teamName"
                    [label]="'Group Name'"
                    [errorMessage]="'Please enter the first name of the group.'"
                    [submitted]="submitted"
                    [icon]="'assets/svg/information-circle.svg'" />
                </tidy-row>
              }
            }
          }
        </tidy-card>
        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }
        <tidy-button
          [text]="'Update Info'"
          [action]="boundUpdateMember"
          class="primary" />
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
